<!-- NOTE: this modal is used for both online and live RoundTables -->
<template lang="html">
  <pl-dialog
    @close="$emit('close')"
    padding="0 0 20px 0"
    :size="'lg'"
    :disableOutsideClick="true"
    :title="
      activityType == 'live'
        ? 'Welcome to the Verbal RoundTable'
        : 'Welcome to the Written RoundTable'
    "
  >
    <div
      class="main-container w-100 h-100 flex justify-center mt-5 py-16"
      style="overflow: auto"
    >
      <!-- TEACHERS -->
      <div
        class="card-video-body col-xs-5 col-sm-5 col-md-5 col-lg-5"
        v-if="hasTeacherPermissionsInCourse && showTeacher"
      >
        <h3 class="modal-sub-title">For Teachers</h3>
        <div class="video-container" style="">
          <iframe
            width="100%"
            height="100%"
            :src="welcomeSettingsForTeacher.video_url"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          />
          <div class="mt3" style="text-align: center !important">
            <div
              v-for="(link, index) in welcomeSettingsForTeacher.links"
              class="mt1"
            >
              <a
                style="margin: 10px 0px"
                class="row tutorials-list no-margin middle-xs between-xs"
                :key="index"
                :href="link.url"
                target="_blank"
              >
                {{ link.name }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- STUDENTS -->
      <div
        class="card-video-body col-xs-5 col-sm-5 col-md-5 col-lg-5"
        v-if="showStudent"
      >
        <h3 class="modal-sub-title">For Students</h3>
        <div class="video-container" style="">
          <iframe
            width="100%"
            height="100%"
            :src="welcomeSettingsForStudent.video_url"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          />

          <div class="mt3" style="text-align: center !important">
            <div
              v-for="(link, index) in welcomeSettingsForStudent.links"
              class="mt1"
              @click="openLinkNewTab(link.url)"
            >
              <a
                style="margin: 10px 0px"
                class="row tutorials-list no-margin middle-xs between-xs"
                :key="index"
                :href="link.url"
                target="_blank"
              >
                {{ link.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import getWelcomeSettings from 'services/account/getWelcomeSettings';

  export default {
    data() {
      return {
        welcomeSettings: [],
        welcomeSettingsForTeacher: {},
        welcomeSettingsForStudent: {},
        showStudent: true,
        showTeacher: true,
        rt_type: '',
      };
    },
    components: {},
    props: {
      activityType: {
        type: String,
        default: '',
      },
      data: {
        type: Array,
        default: [],
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'getCurrentDiscussion',
        'getProfile',
        'hasTeacherPermissionsInCourse',
      ]),
    },
    methods: {
      getLinks() {
        getWelcomeSettings
          .getSettingsByQuery(this.rt_type)
          .then((data) => {
            this.welcomeSettings = data;
            if (this.welcomeSettings && this.welcomeSettings.length >= 0) {
              this.welcomeSettings.map(
                (v) => (v.video_url = this.formatVideo(v.video_url))
              );
              this.showStudent = this.welcomeSettingsForStudent.enabled;
              this.showTeacher = this.welcomeSettingsForTeacher.enabled;
            }
          })
          .catch(console.error);
      },
      formatVideo(video) {
        if (video) {
          var video_id = video.split('v=')[1];
          if (video_id) {
            var ampersandPosition = video_id.indexOf('&');
            if (ampersandPosition != -1) {
              video_id = video_id.substring(0, ampersandPosition);
            }
            return 'https://www.youtube.com/embed/' + video_id;
          }
        }
        return video;
      },
      setWelcomeSettings() {
        this.welcomeSettings.forEach((setting) => {
          if (
            setting.role === 'teacher' &&
            setting.roundtable_type === this.activityType
          ) {
            this.welcomeSettingsForTeacher = setting;
          } else if (
            setting.role === 'student' &&
            setting.roundtable_type === this.activityType
          ) {
            this.welcomeSettingsForStudent = setting;
          }
        });
      },
      openLinkNewTab(url) {
        window.open(`${url}`);
      },
    },
    mounted() {
      if (this.data === []) {
        this.getLinks();
      } else {
        this.welcomeSettings = this.data;
        if (this.welcomeSettings && this.welcomeSettings.length >= 0) {
          this.welcomeSettings.map((v) => {
            v.video_url = this.formatVideo(v.video_url);
          });

          this.setWelcomeSettings();

          this.showStudent = this.welcomeSettingsForStudent.enabled;
          this.showTeacher = this.welcomeSettingsForTeacher.enabled;
        }
      }
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .modal-title {
    margin-top: 35px;
    margin-bottom: 20px;
    color: #292929;
    font-weight: bold;
    text-align: center;
  }

  .modal-sub-title {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center !important;
  }
  .main-container
    &&::-webkit-scrollbar
      display: block !important;
      width: 10px !important;
      -webkit-appearance: none;

  .card-video-body {
    max-width: 400px;

    .video-container {
      width = '200px';
      height = '150px';

      @media only screen and (max-width: 600px) {
        height: 12em;

        iframe {
          height: 12em;
        }
      }

      @media only screen and (min-width: 600px) {
        height: 17em;

        iframe {
          height: 17em;
        }
      }

      .video-frame {
        width: 100%;
      }
    }
  }

  .tutorials-list {
    display: contents;
    color: #292929 !important;
    font-weight: bold;
  }
</style>
<style lang="scss">
  // TODO: change in the future to use v-deep
  .modal-background .modal-content {
    .modal-body {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// roundTableWelcomeModal.vue?68054449